import { get } from 'lodash';
import GenerateRequest from './resources';
import { checkLicenseExpiry } from './ResourceValidations';

const req = GenerateRequest();
const defaultColorScheme = {
  prefab: '#375686',
  complete: '#489b64',
  coordination: '#f3b54a',
  detailing: '#e89d78',
  manufacturing: '#fe8137',
  qa: '#a64d00',
  sourcing: '#867437',
  delivery: '#6f3000',
  inTransit: '#43aac7',
  fulfilled: '#489b64',
  notStarted: '#4d93ff',
  inStorage: '#1470ff',
  preparation: '#fff000',
  rejected: '#fff000',
  ordering: '#c0ab42',
  fieldverify: '#867437',
  mixColor: '#5e467b',
  catalogue: '#818278',
  zombie: '#489b64',
  releasedToInventory: '#3e3edc',
  mixDelivery: '#5e467b',
  consumed: '#BD9BB5',
  noWorkflow: '#FF392E',
  pending: '#FDFD96',
  submitted: '#77DD77',
  approved: '#46b846',
  approvedAsNoted: '#20d020',
  forRecordOnly: '#059c05',
  reviseAndResubmit: '#cd5d57',
  void: '#7b3734',
  unScheduled: '#FD7700'
};
let colorScheme = null;

export default {
  async getOne(id) {
    try {
      await checkLicenseExpiry();
      return (await req.get('companies/get', { params: { id } })).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  defaultColorSchemes() {
    return defaultColorScheme;
  },
  async colorSchemes(id) {
    try {
      await checkLicenseExpiry();
      colorScheme = (await req.get('companies/getColorSchemes', { params: { company: id } })).data;
      return { ...defaultColorScheme, ...colorScheme };
    } catch (e) {
      console.log(e);
      return defaultColorScheme;
    }
  },
  async qrLabel(id) {
    try {
      await checkLicenseExpiry();
      return (await req.get('companies/getQrLabel', { params: { company: id } })).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async save(company) {
    try {
      await checkLicenseExpiry();
      return (await req.post('companies/update', { company })).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async updateMeasureUnit(company) {
    try {
      await checkLicenseExpiry();
      return (await req.post('companies/updateMeasureUnit', { company })).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async updateQaqcTypes(company) {
    try {
      await checkLicenseExpiry();
      return (await req.post('companies/updateQaqcTypes', { company })).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async updateSecurity(company) {
    try {
      await checkLicenseExpiry();
      return (await req.post('companies/updateSecurity', { company })).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async saveColor(colors) {
    try {
      await checkLicenseExpiry();
      return (await req.post('companies/saveColorScheme', colors)).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async saveQrLabel(data) {
    try {
      await checkLicenseExpiry();
      return (await req.post('companies/saveQrLabel', data)).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async updateCompanyUserRelation(data) {
    try {
      await checkLicenseExpiry();
      return (await req.post('companies/updateCompanyUserRelation', data)).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async sendActivationMail(params) {
    try {
      await checkLicenseExpiry();
      return (await req.post('companies/sendActivationMail', params)).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async getCompanyRuns(params) {
    try {
      await checkLicenseExpiry();
      return (await req.get('companies/getCompanyRuns', { params: { type: params } })).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async resetPassword(params = {}) {
    try {
      await checkLicenseExpiry();
      const user = await req.post('/accounts/resetPassword', params);
      return user.data;
    } catch (e) {
      console.error(`Error: ${e.message}`);
      throw e;
    }
  },
  async isRunUsed(params) {
    try {
      const { data } = await req.post('companies/isRunUsed', params);
      return data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  async usedLocations() {
    try {
      await checkLicenseExpiry();
      const { data } = await req.get('companies/usedLocations', {});
      return data.usedLocations;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async reNameRun(params) {
    try {
      await checkLicenseExpiry();
      return (await req.post('companies/reNameRun', params)).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async updateItemMeasureUnit(params) {
    try {
      await checkLicenseExpiry();
      return (await req.post('companies/updateItemMeasureUnit', params)).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async getAvailablePermissions() {
    try {
      await checkLicenseExpiry();
      return (await req.get('companies/getAvailablePermissions')).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async getPermissionGroups() {
    try {
      await checkLicenseExpiry();
      return (await req.get('companies/getPermissionGroups')).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async createUpdatePermissionGroups(params) {
    try {
      await checkLicenseExpiry();
      const res = await req.post(`companies/updatePermission/${params.id}`, params);
      return res;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error
    }
  },
  async deletePermissionGroup(groupId) {
    try {
      await checkLicenseExpiry();
      const res = await req.delete(`companies/deletePermission/${groupId}`);
      return res;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async getPermissionGroupCount() {
    try {
      await checkLicenseExpiry();
      return (await req.get('companies/getPermissionGroupCount')).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async getTags(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.get('tags', { params });
      return data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async addTags(params) {
    try {
      await checkLicenseExpiry();
      const { data: newTag } = await req.post(params.project ? `tags/add/${params.project}` : 'tags/add', params);
      return newTag;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async addQaQcTypes(params) {
    try {
      const { data: newTag } = await req.post(params.project ? `qaqcTypes/add/${params.project}` : 'qaqcTypes/add', params);
      return newTag;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  async updateTag(params) {
    try {
      await checkLicenseExpiry();
      const pId = get(params, 'project._id');
      const updatedTag = await req.post(pId ? `tags/edit/${pId}` : 'tags/edit', params);
      return updatedTag;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async archiveTag(tagId, pId = null) {
    try {
      await checkLicenseExpiry();
      const { data: archivedTags } = await req.post(pId ? `tags/archive/${pId}/${tagId}` : `tags/archive/${tagId}`);
      return archivedTags;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async resetPermissionGroup(id) {
    try {
      await checkLicenseExpiry();
      const { data: updatedGroup } = await req.post(`companies/resetPermissionGroup/${id}`);
      return updatedGroup;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
};
